import React from "react";
import "./App.css";
import { Header } from "./components/Header";
import { HeroSection } from "./components/HeroSection";
import { WhyClientsSection } from "./components/WhyClientsSection";
import { CredentialsSection } from "./components/CredentialsSection";
import { AboutMeSection } from "./components/AboutMeSection";
import { QueerAffirmativeSection } from "./components/QueerAffirmativeSection";
import { FAQSection } from "./components/FAQSection";
import { ContactSection } from "./components/ContactSection";
import { Footer } from "./components/Footer";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <Header />
      <main className="pt-20">
        <HeroSection />
        <WhyClientsSection />
        <div id="credentials">
          <CredentialsSection />
        </div>
        <div id="about">
          <AboutMeSection />
        </div>
        <QueerAffirmativeSection />
        <div id="faqs">
          <FAQSection />
        </div>
        <ContactSection />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;
